import {toggleAreaExpend} from "../elements/inputs";
import {noBreackingSpace} from "./noBreackingPoints";


let popin = $("#popin-instantane")
let popinContent = $("#popin-instantane .popin-container")
let closeButtonPopin = $("#close-popin-instantane")
//EditLinkButton
let editAdminButton = $('#admin_edit')
let defaultEditLink = editAdminButton.attr("href")

//Open preview single
const urlParams = new URLSearchParams(window.location.search)
let postId = urlParams.get('preview_instantane')
if (postId) loadSingle(parseInt(postId))


if (popin.length) {
    $(document).on('click', '.card-instantane.open-popin[post-id], .card-search .open-popin[post-id]', function (e) {
        e.preventDefault();
        loadSingle($(this).attr('post-id'))
    });

    closeButtonPopin.click(function (e) {
        e.preventDefault();
        window.history.back();
    })
}

//Event close popin
$(document).keyup(function(e) {
    if (e.key === "Escape" && popinIsOpen()) { // escape key maps to keycode `27`
        closePopin()
    }
});

//On navigate on history
window.onhashchange = function(e) {
    // e.preventDefault()
    // console.log(e, popinIsOpen())

    let oldHash = e.oldURL.substr(e.oldURL.indexOf('#'))
    oldHash = (oldHash.includes("#instantane=")) ? oldHash : null

    let newHash = e.newURL.substr(e.newURL.indexOf('#'))
    newHash = (newHash.includes("#instantane=")) ? newHash : null

    // console.log(popinIsOpen(), oldHash, newHash)
    if (popinIsOpen() && !newHash) {
        closePopin()
    } else if (!popinIsOpen() && newHash) {
        loadSingle(newHash.replace('#instantane=', ''))
    }
}

//On navigate with tak key of keyboard
$(document).keyup(function(e) {
    if (e.keyCode === 9 && popinIsOpen()) {
        let isInPopin = $('#popin-instantane').find(e.target).length
        if (!isInPopin) {
            e.preventDefault()
            $("#close-popin-instantane").focus()
        }
    }
});
$(document).keydown(function(e) {
    if (e.keyCode === 9 && popinIsOpen()) {
        let isInPopin = $('#popin-instantane').find(e.target).length
        if (!isInPopin) e.preventDefault()
    }
});

function openPopin(postId) {
    $("body").css("overflow", "hidden")
    if (popin.attr("aria-expanded") != "true") toggleAreaExpend(popin)
    window.location.hash = "instantane="+postId
    popin.get(0).scrollTop = 0
    $("#close-popin-instantane").focus()
    $("#close-popin-instantane").attr('tabindex', '0')
}

function closePopin() {
    editAdminButton.attr('href', defaultEditLink)
    $("body").css("overflow", "")
    popin.find('.popin-container').html("")
    $("#close-popin-instantane").attr('tabindex', '-1')
    toggleAreaExpend(popin)
    if (window.location.hash) window.location.hash = "";
}


function popinIsOpen() {
    return ($("#popin-instantane").attr("aria-expanded") === 'true')
}


//Reload post result
function loadSingle(postId) {
    fetch(resturl+'loadsingle', {
        method: 'POST',
        headers: {'Accept': 'application/json'},
        body: JSON.stringify({
            'post_id': postId,
        }),
    }).then(function (res) {
        if (res.ok) return res.json()
    }).then(function (data) {
        if (data.single) {
            popinContent.html(data.single)
            noBreackingSpace(popinContent)
            let editLink = rootUrl+'/wp-admin/post.php?post='+postId+'&action=edit'
            editAdminButton.attr('href', editLink)
            editAdminButton.attr('target', '_blank')
            openPopin(postId)
        }
    }).catch(function (error) {
        console.error(error)
    })
}
